// extracted by css-extract-rspack-plugin
export default {"root":"p82VFa"};